import React, { useEffect, useState } from "react"
import DatePicker from "react-multi-date-picker"

export default function Calendar(props) {
  const today = new Date()
  const [values, setValues] = useState(props.endDateValues)

  useEffect(() => {
    setValues(props.endDateValues)
  }, props.endDateValues)

  const CustomMultipleInput =({openCalendar, value}) => {
    return (
      <input
        onFocus={openCalendar}
        className = 'rmdp-input'
        value={value.length > 0 ? value[6]: ''}
        readOnly
      />
    )
  }

  return (
    <DatePicker 
      multiple
      minDate={new Date()}
      value={values} 
      format='MM/DD/YYYY'
      render={<CustomMultipleInput />}
    />
  )
}


// WEBPACK FOOTER //
// ./src/components/assignments/EndCalendar.js